export const DY_EVENTS = {
  init: 'dyEvents/init',
} as const;

export type DYEventsInterface = {
  'dyEvents/init': null;
};
